export default {
  items: [
    {
      name: 'Relatórios',
      icon: 'fa fa-book',
      children: [
        {
          name: 'Dashboard',
          url: '/relatorios/dashboard',
          icon: 'fa fa-file'
        },
        // {
        //   name: 'Usuários por Situação',
        //   url: '/relatorios/usuarios-situacao',
        //   icon: 'fa fa-file'
        // },
        // {
        //   name: 'Usuários por Tipo',
        //   url: '/relatorios/usuarios-tipo',
        //   icon: 'fa fa-file'
        // },
        // {
        //   name: 'Beneficiárias vinculadas a Voluntárias',
        //   url: '/relatorios/usuarios-vinculo',
        //   icon: 'fa fa-file'
        // },
        // {
        //   name: 'Idade média das beneficiárias e voluntárias',
        //   url: '/relatorios/usuarios-idade',
        //   icon: 'fa fa-file'
        // },
        {
          name: 'Quantidade total de usuários por tipo em números',
          url: '/relatorios/usuarios-total',
          icon: 'fa fa-file'
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_navVisualizador.js